import React from 'react';

import type { MatchFragment } from '@swf/generated/graphql/scoreboards/operations';
import type { TennisStatusReason } from '@swf/generated/graphql/scoreboards/schemas';
import type { IconName } from '@swf/sports/types/icon';

import EventStatusMessage from '../../EventStatusMessage/EventStatusMessage';

import PreviousSetsScore from './PreviousSetScore';

type TennisStatusReasonToIconNameMap = {
  [P in TennisStatusReason]?: IconName;
};

const tennisStatusReasonToIconNameMap: TennisStatusReasonToIconNameMap = {
  RAIN_DELAY: 'break',
  HEAT_DELAY: 'break',
  TOILET_BREAK: 'break',
  FINISHED: 'finished'
};

export interface Props {
  tennisMatch: MatchFragment;
}

const TennisScoreboardInPlayStatus: React.FC<Props> = ({ tennisMatch }) => {
  const { previousSets, status, currentSet } = tennisMatch;
  const reason = status?.reason;

  const isInterruptedStatus = status?.status === 'INTERRUPTED';
  const isTieBreak = currentSet?.currentGame?.type === 'TIEBREAK';

  const eventScoreComponent = previousSets?.length ? (
    <PreviousSetsScore previousSets={previousSets} />
  ) : undefined;

  if (isTieBreak && isInterruptedStatus && reason) {
    return (
      <EventStatusMessage
        eventScoreComponent={eventScoreComponent}
        messageId={reason}
        iconName={tennisStatusReasonToIconNameMap[reason]}
        size="XSmall"
      />
    );
  }

  if (isTieBreak) {
    return (
      <EventStatusMessage
        eventScoreComponent={eventScoreComponent}
        messageId="TIE_BREAK"
        iconName="in-play"
        size="XSmall"
      />
    );
  }

  if (reason) {
    return (
      <EventStatusMessage
        eventScoreComponent={eventScoreComponent}
        messageId={reason}
        iconName={tennisStatusReasonToIconNameMap[reason] || 'in-play'}
        size="XSmall"
      />
    );
  }

  return (
    <EventStatusMessage
      eventScoreComponent={eventScoreComponent}
      messageId="IN_PLAY"
      iconName="in-play"
      size="XSmall"
    />
  );
};

export default TennisScoreboardInPlayStatus;
